import React from "react";
import { Box, useMantineColorScheme } from "@mantine/core";

import { RobotsNoindex } from "@shared/components";
import { RETURN_PATH_KEY } from "@shared/constants";
import { getSafeRedirect } from "@shared/utils";

import { SignInOptions } from "./components/SignInOptions";
import { ValueProps } from "./components/ValueProps";

import styles from "./Login.module.css";

const getReturnPathParam = () => {
  const params = new URLSearchParams(window.location.search);
  return getSafeRedirect(params.get(RETURN_PATH_KEY));
};

export const Login: React.FC = () => {
  const { colorScheme } = useMantineColorScheme();

  return (
    <>
      {/* Google shouldn't index the login page when it was trying to open an authed page */}
      {getReturnPathParam() && <RobotsNoindex />}
      {/* Actual Login Content */}
      <Box data-testid="Login" className={styles.loginComponentContainer}>
        <ValueProps colorScheme={colorScheme} />
        <SignInOptions colorScheme={colorScheme} />
      </Box>
    </>
  );
};
